import { SupportedLanguage } from '../i18n/translations';

export type CountrySlug = 'jordan' | 'iraq' | 'uae' | 'saudi' | 'lebanon' | 'egypt' | 'qatar' | 'libya' | 'tunisia' | 'algeria' | 'morocco';

interface CountryCopy {
  name: string;
  title: string;
  description: string;
  h1: string;
  intro: string;
  paragraphs: string[];
  crossingsTitle: string;
  crossings: string[];
  cta: string;
}

export const countrySlugs: CountrySlug[] = ['jordan', 'iraq', 'uae', 'saudi', 'lebanon', 'egypt', 'qatar', 'libya', 'tunisia', 'algeria', 'morocco'];

export const countryPages: Record<CountrySlug, Record<SupportedLanguage, CountryCopy>> = {
  jordan: {
    ar: {
      name: 'الأردن',
      title: 'تخليص جمركي لشحنات الأردن | الشراع - معبر نصيب',
      description: 'شركة الشراع تنجز التخليص الجمركي في سوريا لشحنات المستوردين والمصدّرين من الأردن عبر معبر نصيب وجابر نصيب وميناء اللاذقية.',
      h1: 'تخليص جمركي لشحنات الأردن عبر سوريا',
      intro: 'نخدم التجار والشركات في الأردن الذين يحتاجون إلى تخليص جمركي داخل سوريا للاستيراد أو التصدير عبر المعابر البرية والموانئ.',
      paragraphs: [
        'معبر نصيب هو المنفذ البري الرئيسي بين سوريا والأردن. تتولى الشراع إنهاء البيان الجمركي، تصنيف البضاعة، ومتابعة الكشف حتى عبور الشحنة.',
        'نتعامل مع شحنات المواد الغذائية، المنسوجات، الإلكترونيات، والآلات القادمة من عمّان أو المتجهة إليها، مع تجهيز الوثائق المطلوبة مثل الفاتورة وشهادة المنشأ وقائمة التعبئة.',
        'إذا كانت شحنتك تمر عبر ميناء اللاذقية ثم تخرج براً إلى الأردن، ننسّق التخليص البحري والبري في مسار واحد لتفادي التأخير.',
      ],
      crossingsTitle: 'المعابر المستخدمة لشحنات الأردن',
      crossings: ['معبر نصيب', 'معبر جابر نصيب', 'ميناء اللاذقية', 'مطار دمشق الدولي'],
      cta: 'اطلب تخليص شحنة من الأردن أو إليه',
    },
    en: {
      name: 'Jordan',
      title: 'Customs clearance for Jordan shipments | Al Shiraa - Nasib',
      description: 'Al Shiraa handles Syrian customs clearance for Jordanian importers and exporters via Nasib, Jaber Nasib and Latakia port.',
      h1: 'Customs clearance for Jordan cargo through Syria',
      intro: 'We serve traders in Jordan who need customs clearance inside Syria for import or export via land borders and ports.',
      paragraphs: [
        'Nasib is the main land crossing between Syria and Jordan. Al Shiraa completes the customs declaration, classification, and inspection follow-up until the cargo crosses.',
        'We handle food, textiles, electronics and machinery moving to or from Amman, including invoices, certificates of origin and packing lists.',
        'If cargo arrives at Latakia port then continues by road to Jordan, we coordinate sea and land clearance in one workflow.',
      ],
      crossingsTitle: 'Crossings used for Jordan shipments',
      crossings: ['Nasib crossing', 'Jaber Nasib crossing', 'Latakia port', 'Damascus International Airport'],
      cta: 'Request clearance for a Jordan shipment',
    },
    de: {
      name: 'Jordanien',
      title: 'Zollabfertigung für Jordanien | Al Shiraa - Nasib',
      description: 'Al Shiraa erledigt die Zollabfertigung in Syrien für jordanische Importeure und Exporteure über Nasib und den Hafen Latakia.',
      h1: 'Zollabfertigung für Sendungen aus Jordanien',
      intro: 'Wir betreuen Händler in Jordanien, die eine Zollabfertigung in Syrien über Landgrenzen und Häfen benötigen.',
      paragraphs: [
        'Nasib ist der wichtigste Landübergang zwischen Syrien und Jordanien. Wir erstellen die Zollanmeldung und begleiten die Beschau bis zur Ausreise.',
        'Wir bearbeiten Lebensmittel, Textilien, Elektronik und Maschinen von und nach Amman inklusive Rechnungen und Ursprungszeugnissen.',
        'Kommt die Ware über Latakia und weiter per Lkw nach Jordanien, koordinieren wir See- und Landabfertigung in einem Ablauf.',
      ],
      crossingsTitle: 'Übergänge für Jordanien',
      crossings: ['Nasib', 'Jaber Nasib', 'Hafen Latakia', 'Flughafen Damaskus'],
      cta: 'Abfertigung für eine Jordanien-Sendung anfragen',
    },
  },
  iraq: {
    ar: {
      name: 'العراق',
      title: 'تخليص جمركي لشحنات العراق | الشراع - أبو كمال والقامشلي',
      description: 'تخليص جمركي في سوريا لشحنات العراق عبر معبر أبو كمال ومعبر القامشلي وميناء اللاذقية. خدمة للمستوردين العراقيين.',
      h1: 'تخليص جمركي لشحنات العراق عبر سوريا',
      intro: 'ننجز إجراءات التخليص الجمركي داخل سوريا للشركات والتجار في العراق، سواء كانت البضاعة داخلة إلى سوريا أو خارجة نحو العراق.',
      paragraphs: [
        'معبر أبو كمال ومعبر القامشلي هما المنفذان البريّان الأساسيان نحو العراق. نتابع البيان الجمركي والكشف والتحميل حتى تسليم الشحنة.',
        'نخدم شحنات المواد الإنشائية، الغذائية، والآلات، ونراجع البند الجمركي (HS Code) لتفادي الغرامات أو إعادة التصنيف.',
        'يمكن إدخال البضاعة بحراً عبر اللاذقية ثم نقلها براً إلى العراق، ونتولى التنسيق بين الميناء والمعبر.',
      ],
      crossingsTitle: 'المعابر المستخدمة لشحنات العراق',
      crossings: ['معبر أبو كمال', 'معبر القامشلي', 'ميناء اللاذقية', 'ميناء طرطوس'],
      cta: 'اطلب تخليص شحنة من العراق أو إليه',
    },
    en: {
      name: 'Iraq',
      title: 'Customs clearance for Iraq shipments | Al Shiraa',
      description: 'Syrian customs clearance for Iraqi cargo via Abu Kamal, Qamishli and Latakia port.',
      h1: 'Customs clearance for Iraq cargo through Syria',
      intro: 'We complete customs procedures inside Syria for Iraqi companies, whether cargo is entering Syria or moving on to Iraq.',
      paragraphs: [
        'Abu Kamal and Qamishli are the main land routes toward Iraq. We follow the declaration, inspection and loading until handover.',
        'We handle construction materials, food and machinery, and review HS codes to avoid reclassification or penalties.',
        'Cargo can arrive by sea at Latakia then continue by road to Iraq; we coordinate port and border steps together.',
      ],
      crossingsTitle: 'Crossings used for Iraq shipments',
      crossings: ['Abu Kamal crossing', 'Qamishli crossing', 'Latakia port', 'Tartous port'],
      cta: 'Request clearance for an Iraq shipment',
    },
    de: {
      name: 'Irak',
      title: 'Zollabfertigung für den Irak | Al Shiraa',
      description: 'Zollabfertigung in Syrien für irakische Sendungen über Abu Kamal, Qamishli und Latakia.',
      h1: 'Zollabfertigung für Sendungen aus dem Irak',
      intro: 'Wir erledigen die Zollformalitäten in Syrien für irakische Unternehmen, egal ob die Ware nach Syrien kommt oder weiter in den Irak geht.',
      paragraphs: [
        'Abu Kamal und Qamishli sind die wichtigsten Landwege in den Irak. Wir begleiten Anmeldung, Beschau und Verladung.',
        'Wir bearbeiten Baustoffe, Lebensmittel und Maschinen und prüfen HS-Codes, um Nachverzollung zu vermeiden.',
        'Ware kann über Latakia ankommen und per Straße in den Irak weiterfahren; wir koordinieren Hafen und Grenze.',
      ],
      crossingsTitle: 'Übergänge für den Irak',
      crossings: ['Abu Kamal', 'Qamishli', 'Hafen Latakia', 'Hafen Tartous'],
      cta: 'Abfertigung für eine Irak-Sendung anfragen',
    },
  },
  uae: {
    ar: {
      name: 'الإمارات',
      title: 'تخليص جمركي لشحنات الإمارات | الشراع - دبي وأبوظبي',
      description: 'تخليص جمركي في سوريا لشحنات التجار من دبي وأبوظبي عبر ميناء اللاذقية والمطارات السورية.',
      h1: 'تخليص جمركي لشحنات الإمارات عبر سوريا',
      intro: 'نخدم الشركات في دبي وأبوظبي التي تشحن بضائعها إلى سوريا أو تعيد تصديرها عبر الموانئ والمطارات السورية.',
      paragraphs: [
        'كثير من شحنات الإمارات تصل بحراً إلى ميناء اللاذقية أو جواً إلى مطار دمشق. نستلم الملف الجمركي منذ وصول الحاوية أو البوليصة.',
        'نجهّز الوثائق، نراجع التصنيف الجمركي، ونتابع الكشف والإفراج لتسليم البضاعة للمستورد في سوريا أو لإعادة التصدير.',
        'التجار في المناطق الحرة بدبي يمكنهم العمل معنا عن بعد عبر واتساب أو البريد، ونرسل تحديثات كل مرحلة.',
      ],
      crossingsTitle: 'المنافذ المستخدمة لشحنات الإمارات',
      crossings: ['ميناء اللاذقية', 'ميناء طرطوس', 'مطار دمشق الدولي', 'مطار حلب الدولي'],
      cta: 'اطلب تخليص شحنة من الإمارات',
    },
    en: {
      name: 'United Arab Emirates',
      title: 'Customs clearance for UAE shipments | Al Shiraa - Dubai',
      description: 'Syrian customs clearance for Dubai and Abu Dhabi traders via Latakia port and Syrian airports.',
      h1: 'Customs clearance for UAE cargo through Syria',
      intro: 'We serve companies in Dubai and Abu Dhabi shipping goods into Syria or re-exporting through Syrian ports and airports.',
      paragraphs: [
        'Many UAE shipments arrive by sea at Latakia or by air in Damascus. We take over the file from container or AWB arrival.',
        'We prepare documents, review tariff classification, and follow inspection through release or re-export.',
        'Free-zone traders in Dubai can work with us remotely by WhatsApp or email and receive status updates at each step.',
      ],
      crossingsTitle: 'Gateways used for UAE shipments',
      crossings: ['Latakia port', 'Tartous port', 'Damascus International Airport', 'Aleppo International Airport'],
      cta: 'Request clearance for a UAE shipment',
    },
    de: {
      name: 'VAE',
      title: 'Zollabfertigung für die VAE | Al Shiraa - Dubai',
      description: 'Zollabfertigung in Syrien für Händler aus Dubai und Abu Dhabi über Latakia und syrische Flughäfen.',
      h1: 'Zollabfertigung für Sendungen aus den VAE',
      intro: 'Wir betreuen Unternehmen in Dubai und Abu Dhabi, die Ware nach Syrien senden oder über syrische Häfen reexportieren.',
      paragraphs: [
        'Viele VAE-Sendungen kommen per Schiff in Latakia oder per Luftfracht in Damaskus an. Wir übernehmen das Dossier ab Ankunft.',
        'Wir bereiten Unterlagen vor, prüfen die Tarifierung und begleiten die Beschau bis zur Freigabe oder zum Reexport.',
        'Händler in den Freihandelszonen Dubais können remote über WhatsApp oder E-Mail mit uns arbeiten.',
      ],
      crossingsTitle: 'Zugänge für VAE-Sendungen',
      crossings: ['Hafen Latakia', 'Hafen Tartous', 'Flughafen Damaskus', 'Flughafen Aleppo'],
      cta: 'Abfertigung für eine VAE-Sendung anfragen',
    },
  },
  saudi: {
    ar: {
      name: 'السعودية',
      title: 'تخليص جمركي لشحنات السعودية | الشراع',
      description: 'تخليص جمركي في سوريا لبضائع المستوردين والمصدّرين في السعودية عبر المعابر البرية وميناء اللاذقية.',
      h1: 'تخليص جمركي لشحنات السعودية عبر سوريا',
      intro: 'نخدم الشركات في السعودية التي تحتاج إلى تخليص جمركي داخل سوريا لشحنات الاستيراد أو التصدير أو الترانزيت.',
      paragraphs: [
        'الشحنات السعودية تصل غالباً عبر الموانئ السورية أو عبر الطرق الإقليمية المرتبطة بالأردن ثم معبر نصيب. نحدد المسار الأنسب حسب نوع البضاعة.',
        'نراجع الوثائق، البند الجمركي، ومتطلبات الجهات الرقابية قبل وصول الشحنة لتقليل وقت الانتظار على المعبر أو في الميناء.',
        'يمكن متابعة الملف عن بعد من الرياض أو جدة أو الدمام، مع تقرير واضح بكل رسوم وإجراء.',
      ],
      crossingsTitle: 'المنافذ المستخدمة لشحنات السعودية',
      crossings: ['معبر نصيب', 'ميناء اللاذقية', 'ميناء طرطوس', 'مطار دمشق الدولي'],
      cta: 'اطلب تخليص شحنة من السعودية',
    },
    en: {
      name: 'Saudi Arabia',
      title: 'Customs clearance for Saudi shipments | Al Shiraa',
      description: 'Syrian customs clearance for Saudi importers and exporters via land borders and Latakia port.',
      h1: 'Customs clearance for Saudi cargo through Syria',
      intro: 'We serve companies in Saudi Arabia that need customs clearance inside Syria for import, export or transit cargo.',
      paragraphs: [
        'Saudi shipments often arrive via Syrian ports or regional roads linked through Jordan and Nasib. We choose the route that fits the cargo.',
        'We review documents, HS codes and regulatory requirements before arrival to cut waiting time at the border or port.',
        'Files can be handled remotely from Riyadh, Jeddah or Dammam, with a clear report of fees and steps.',
      ],
      crossingsTitle: 'Gateways used for Saudi shipments',
      crossings: ['Nasib crossing', 'Latakia port', 'Tartous port', 'Damascus International Airport'],
      cta: 'Request clearance for a Saudi shipment',
    },
    de: {
      name: 'Saudi-Arabien',
      title: 'Zollabfertigung für Saudi-Arabien | Al Shiraa',
      description: 'Zollabfertigung in Syrien für saudische Importeure und Exporteure über Landgrenzen und Latakia.',
      h1: 'Zollabfertigung für Sendungen aus Saudi-Arabien',
      intro: 'Wir betreuen Unternehmen in Saudi-Arabien, die eine Zollabfertigung in Syrien für Import, Export oder Transit brauchen.',
      paragraphs: [
        'Saudische Sendungen kommen oft über syrische Häfen oder regionale Straßen über Jordanien und Nasib. Wir wählen die passende Route.',
        'Wir prüfen Papiere, HS-Codes und behördliche Vorgaben vor Ankunft, um Wartezeiten zu verkürzen.',
        'Die Akte kann remote aus Riad, Dschidda oder Dammam geführt werden, mit klarem Bericht zu Gebühren und Schritten.',
      ],
      crossingsTitle: 'Zugänge für Saudi-Sendungen',
      crossings: ['Nasib', 'Hafen Latakia', 'Hafen Tartous', 'Flughafen Damaskus'],
      cta: 'Abfertigung für eine Saudi-Sendung anfragen',
    },
  },
  lebanon: {
    ar: {
      name: 'لبنان',
      title: 'تخليص جمركي لشحنات لبنان | الشراع',
      description: 'تخليص جمركي في سوريا للشحنات من وإلى لبنان عبر الطرق البرية وميناء اللاذقية ومطار دمشق.',
      h1: 'تخليص جمركي لشحنات لبنان عبر سوريا',
      intro: 'نخدم التجار والشركات في لبنان الذين يحتاجون إلى تخليص جمركي داخل سوريا للشحنات البرية أو البحرية أو الجوية.',
      paragraphs: [
        'بسبب القرب الجغرافي، تمر شحنات كثيرة بين لبنان وسوريا براً. ننسّق الوثائق والإجراءات لتسريع العبور وتفادي احتجاز البضاعة.',
        'إذا وصلت الشحنة إلى ميناء اللاذقية وهي متجهة إلى لبنان أو العكس، نتولى التخليص في الميناء ثم متابعة النقل البري.',
        'نراجع شهادات المنشأ والفاتورة وقائمة التعبئة مسبقاً حتى لا تتوقف الشحنة لنقص ورقة واحدة.',
      ],
      crossingsTitle: 'المنافذ المستخدمة لشحنات لبنان',
      crossings: ['الطرق البرية مع لبنان', 'ميناء اللاذقية', 'ميناء طرطوس', 'مطار دمشق الدولي'],
      cta: 'اطلب تخليص شحنة من لبنان أو إليه',
    },
    en: {
      name: 'Lebanon',
      title: 'Customs clearance for Lebanon shipments | Al Shiraa',
      description: 'Syrian customs clearance for cargo to and from Lebanon via land routes, Latakia port and Damascus airport.',
      h1: 'Customs clearance for Lebanon cargo through Syria',
      intro: 'We serve traders in Lebanon who need customs clearance inside Syria for land, sea or air shipments.',
      paragraphs: [
        'Because of the short distance, many shipments move by road between Lebanon and Syria. We coordinate papers so cargo is not held at the border.',
        'If goods arrive at Latakia and continue to Lebanon, or the reverse, we clear at the port then follow the road movement.',
        'We review certificates of origin, invoices and packing lists in advance so one missing paper does not stop the truck.',
      ],
      crossingsTitle: 'Gateways used for Lebanon shipments',
      crossings: ['Land routes with Lebanon', 'Latakia port', 'Tartous port', 'Damascus International Airport'],
      cta: 'Request clearance for a Lebanon shipment',
    },
    de: {
      name: 'Libanon',
      title: 'Zollabfertigung für den Libanon | Al Shiraa',
      description: 'Zollabfertigung in Syrien für Sendungen von und nach Libanon über Landwege, Latakia und Damaskus.',
      h1: 'Zollabfertigung für Sendungen aus dem Libanon',
      intro: 'Wir betreuen Händler im Libanon, die eine Zollabfertigung in Syrien für Land-, See- oder Luftfracht brauchen.',
      paragraphs: [
        'Wegen der kurzen Distanz laufen viele Sendungen per Straße. Wir koordinieren die Papiere, damit die Ware nicht an der Grenze gehalten wird.',
        'Kommt die Ware in Latakia an und fährt weiter in den Libanon – oder umgekehrt – erledigen wir die Hafenabfertigung und die Weiterfahrt.',
        'Wir prüfen Ursprungszeugnis, Rechnung und Packliste im Voraus, damit ein fehlendes Papier den Lkw nicht stoppt.',
      ],
      crossingsTitle: 'Zugänge für Libanon-Sendungen',
      crossings: ['Landwege mit dem Libanon', 'Hafen Latakia', 'Hafen Tartous', 'Flughafen Damaskus'],
      cta: 'Abfertigung für eine Libanon-Sendung anfragen',
    },
  },
  egypt: {
    ar: {
      name: 'مصر',
      title: 'تخليص جمركي لشحنات مصر | الشراع - ميناء اللاذقية',
      description: 'تخليص جمركي في سوريا لشحنات التجار المصريين عبر ميناء اللاذقية والمطارات السورية.',
      h1: 'تخليص جمركي لشحنات مصر عبر سوريا',
      intro: 'نخدم الشركات والتجار في مصر الذين يحتاجون إلى تخليص جمركي داخل سوريا للشحنات البحرية أو الجوية القادمة من أو المتجهة إلى الموانئ والمطارات السورية.',
      paragraphs: [
        'كثير من الشحنات المصرية تصل بحراً إلى ميناء اللاذقية أو جواً إلى مطار دمشق. نستلم الملف الجمركي منذ وصول الحاوية أو بوليصة الشحن الجوي.',
        'نراجع التصنيف الجمركي والوثائق (الفاتورة، شهادة المنشأ، قائمة التعبئة) قبل الإفراج لتفادي التأخير والغرامات.',
        'يمكن متابعة الملف عن بعد من القاهرة أو الإسكندرية عبر واتساب أو البريد، مع تحديث واضح لكل مرحلة.',
      ],
      crossingsTitle: 'المنافذ المستخدمة لشحنات مصر',
      crossings: ['ميناء اللاذقية', 'ميناء طرطوس', 'مطار دمشق الدولي', 'مطار حلب الدولي'],
      cta: 'اطلب تخليص شحنة من مصر أو إليها',
    },
    en: {
      name: 'Egypt',
      title: 'Customs clearance for Egypt shipments | Al Shiraa - Latakia',
      description: 'Syrian customs clearance for Egyptian traders via Latakia port and Syrian airports.',
      h1: 'Customs clearance for Egypt cargo through Syria',
      intro: 'We serve Egyptian companies that need customs clearance inside Syria for sea or air shipments via Syrian ports and airports.',
      paragraphs: [
        'Many Egyptian shipments arrive by sea at Latakia or by air in Damascus. We take over the file from container or AWB arrival.',
        'We review HS classification and documents before release to avoid delays and penalties.',
        'Files can be handled remotely from Cairo or Alexandria by WhatsApp or email with clear status updates.',
      ],
      crossingsTitle: 'Gateways used for Egypt shipments',
      crossings: ['Latakia port', 'Tartous port', 'Damascus International Airport', 'Aleppo International Airport'],
      cta: 'Request clearance for an Egypt shipment',
    },
    de: {
      name: 'Ägypten',
      title: 'Zollabfertigung für Ägypten | Al Shiraa - Latakia',
      description: 'Zollabfertigung in Syrien für ägyptische Händler über Latakia und syrische Flughäfen.',
      h1: 'Zollabfertigung für Sendungen aus Ägypten',
      intro: 'Wir betreuen ägyptische Unternehmen, die eine Zollabfertigung in Syrien für See- oder Luftfracht brauchen.',
      paragraphs: [
        'Viele ägyptische Sendungen kommen per Schiff in Latakia oder per Luftfracht in Damaskus an.',
        'Wir prüfen Tarifierung und Unterlagen vor der Freigabe, um Verzögerungen zu vermeiden.',
        'Die Akte kann remote aus Kairo oder Alexandria über WhatsApp oder E-Mail geführt werden.',
      ],
      crossingsTitle: 'Zugänge für Ägypten-Sendungen',
      crossings: ['Hafen Latakia', 'Hafen Tartous', 'Flughafen Damaskus', 'Flughafen Aleppo'],
      cta: 'Abfertigung für eine Ägypten-Sendung anfragen',
    },
  },
  qatar: {
    ar: {
      name: 'قطر',
      title: 'تخليص جمركي لشحنات قطر | الشراع',
      description: 'تخليص جمركي في سوريا لشحنات التجار في قطر عبر ميناء اللاذقية والمطارات السورية.',
      h1: 'تخليص جمركي لشحنات قطر عبر سوريا',
      intro: 'نخدم الشركات في قطر التي تشحن بضائعها إلى سوريا أو تعيد تصديرها عبر الموانئ والمطارات السورية.',
      paragraphs: [
        'الشحنات القطرية تصل غالباً جواً أو بحراً إلى اللاذقية ودمشق. ننسّق الإفراج الجمركي ومتابعة الكشف بسرعة.',
        'نجهّز الوثائق ونراجع البنود الجمركية قبل وصول الشحنة لتقليل وقت الانتظار.',
        'يمكن إدارة الملف عن بعد من الدوحة مع تقرير واضح بالرسوم والمراحل.',
      ],
      crossingsTitle: 'المنافذ المستخدمة لشحنات قطر',
      crossings: ['ميناء اللاذقية', 'مطار دمشق الدولي', 'مطار حلب الدولي', 'ميناء طرطوس'],
      cta: 'اطلب تخليص شحنة من قطر',
    },
    en: {
      name: 'Qatar',
      title: 'Customs clearance for Qatar shipments | Al Shiraa',
      description: 'Syrian customs clearance for Qatari traders via Latakia port and Syrian airports.',
      h1: 'Customs clearance for Qatar cargo through Syria',
      intro: 'We serve companies in Qatar shipping goods into Syria or re-exporting through Syrian ports and airports.',
      paragraphs: [
        'Qatari shipments often arrive by air or sea at Latakia and Damascus. We coordinate release and inspection quickly.',
        'We prepare documents and review HS codes before arrival to cut waiting time.',
        'Files can be managed remotely from Doha with a clear fee and milestone report.',
      ],
      crossingsTitle: 'Gateways used for Qatar shipments',
      crossings: ['Latakia port', 'Damascus International Airport', 'Aleppo International Airport', 'Tartous port'],
      cta: 'Request clearance for a Qatar shipment',
    },
    de: {
      name: 'Katar',
      title: 'Zollabfertigung für Katar | Al Shiraa',
      description: 'Zollabfertigung in Syrien für katarische Händler über Latakia und syrische Flughäfen.',
      h1: 'Zollabfertigung für Sendungen aus Katar',
      intro: 'Wir betreuen Unternehmen in Katar, die Ware nach Syrien senden oder über syrische Häfen und Flughäfen reexportieren.',
      paragraphs: [
        'Katarische Sendungen kommen oft per Luft oder See in Latakia und Damaskus an.',
        'Wir bereiten Unterlagen vor und prüfen HS-Codes vor Ankunft.',
        'Die Akte kann remote aus Doha geführt werden, mit klarem Gebührenbericht.',
      ],
      crossingsTitle: 'Zugänge für Katar-Sendungen',
      crossings: ['Hafen Latakia', 'Flughafen Damaskus', 'Flughafen Aleppo', 'Hafen Tartous'],
      cta: 'Abfertigung für eine Katar-Sendung anfragen',
    },
  },
  libya: {
    ar: {
      name: 'ليبيا',
      title: 'تخليص جمركي لشحنات ليبيا | الشراع',
      description: 'تخليص جمركي في سوريا لشحنات التجار الليبيين عبر ميناء اللاذقية والمنافذ السورية.',
      h1: 'تخليص جمركي لشحنات ليبيا عبر سوريا',
      intro: 'نخدم التجار والشركات في ليبيا الذين يحتاجون إلى تخليص جمركي داخل سوريا للشحنات البحرية أو الجوية.',
      paragraphs: [
        'نتعامل مع شحنات الاستيراد والتصدير المرتبطة بالموانئ السورية، مع متابعة البيان والكشف حتى الإفراج.',
        'نراجع الوثائق مسبقاً لتفادي احتجاز الشحنة بسبب نقص مستند أو خطأ في التصنيف.',
        'يمكن التواصل عن بعد ومتابعة كل مرحلة عبر واتساب أو البريد.',
      ],
      crossingsTitle: 'المنافذ المستخدمة لشحنات ليبيا',
      crossings: ['ميناء اللاذقية', 'ميناء طرطوس', 'مطار دمشق الدولي'],
      cta: 'اطلب تخليص شحنة من ليبيا أو إليها',
    },
    en: {
      name: 'Libya',
      title: 'Customs clearance for Libya shipments | Al Shiraa',
      description: 'Syrian customs clearance for Libyan traders via Latakia port and Syrian gateways.',
      h1: 'Customs clearance for Libya cargo through Syria',
      intro: 'We serve Libyan traders who need customs clearance inside Syria for sea or air shipments.',
      paragraphs: [
        'We handle import and export files linked to Syrian ports, from declaration through inspection to release.',
        'Documents are reviewed in advance to avoid holds caused by missing papers or wrong classification.',
        'Remote follow-up is available by WhatsApp or email at every stage.',
      ],
      crossingsTitle: 'Gateways used for Libya shipments',
      crossings: ['Latakia port', 'Tartous port', 'Damascus International Airport'],
      cta: 'Request clearance for a Libya shipment',
    },
    de: {
      name: 'Libyen',
      title: 'Zollabfertigung für Libyen | Al Shiraa',
      description: 'Zollabfertigung in Syrien für libysche Händler über Latakia und syrische Zugänge.',
      h1: 'Zollabfertigung für Sendungen aus Libyen',
      intro: 'Wir betreuen libysche Händler, die eine Zollabfertigung in Syrien für See- oder Luftfracht brauchen.',
      paragraphs: [
        'Wir bearbeiten Im- und Exportakten über syrische Häfen von der Anmeldung bis zur Freigabe.',
        'Unterlagen werden vorab geprüft, um Aufenthalte wegen fehlender Papiere zu vermeiden.',
        'Remote-Betreuung ist per WhatsApp oder E-Mail möglich.',
      ],
      crossingsTitle: 'Zugänge für Libyen-Sendungen',
      crossings: ['Hafen Latakia', 'Hafen Tartous', 'Flughafen Damaskus'],
      cta: 'Abfertigung für eine Libyen-Sendung anfragen',
    },
  },
  tunisia: {
    ar: {
      name: 'تونس',
      title: 'تخليص جمركي لشحنات تونس | الشراع',
      description: 'تخليص جمركي في سوريا لشحنات التجار التونسيين عبر ميناء اللاذقية والمطارات السورية.',
      h1: 'تخليص جمركي لشحنات تونس عبر سوريا',
      intro: 'نخدم الشركات في تونس التي تحتاج إلى تخليص جمركي داخل سوريا للشحنات الواردة أو الصادرة عبر الموانئ والمطارات السورية.',
      paragraphs: [
        'ننسّق إجراءات الإفراج والتصنيف الجمركي للشحنات المرتبطة بسوريا، مع متابعة الكشف والتحميل.',
        'نراجع الفاتورة وشهادة المنشأ وقائمة التعبئة قبل الوصول لتسريع الإفراج.',
        'يمكن إدارة الملف عن بعد من تونس مع تحديثات مرحلية واضحة.',
      ],
      crossingsTitle: 'المنافذ المستخدمة لشحنات تونس',
      crossings: ['ميناء اللاذقية', 'ميناء طرطوس', 'مطار دمشق الدولي'],
      cta: 'اطلب تخليص شحنة من تونس أو إليها',
    },
    en: {
      name: 'Tunisia',
      title: 'Customs clearance for Tunisia shipments | Al Shiraa',
      description: 'Syrian customs clearance for Tunisian traders via Latakia port and Syrian airports.',
      h1: 'Customs clearance for Tunisia cargo through Syria',
      intro: 'We serve Tunisian companies that need customs clearance inside Syria for inbound or outbound shipments.',
      paragraphs: [
        'We coordinate release and classification for Syria-linked shipments, including inspection and loading follow-up.',
        'Invoices, certificates of origin and packing lists are reviewed before arrival to speed release.',
        'Files can be managed remotely from Tunisia with clear milestone updates.',
      ],
      crossingsTitle: 'Gateways used for Tunisia shipments',
      crossings: ['Latakia port', 'Tartous port', 'Damascus International Airport'],
      cta: 'Request clearance for a Tunisia shipment',
    },
    de: {
      name: 'Tunesien',
      title: 'Zollabfertigung für Tunesien | Al Shiraa',
      description: 'Zollabfertigung in Syrien für tunesische Händler über Latakia und syrische Flughäfen.',
      h1: 'Zollabfertigung für Sendungen aus Tunesien',
      intro: 'Wir betreuen tunesische Unternehmen, die eine Zollabfertigung in Syrien brauchen.',
      paragraphs: [
        'Wir koordinieren Freigabe und Tarifierung für Syrien-bezogene Sendungen.',
        'Rechnung, Ursprungszeugnis und Packliste werden vor Ankunft geprüft.',
        'Die Akte kann remote aus Tunesien geführt werden.',
      ],
      crossingsTitle: 'Zugänge für Tunesien-Sendungen',
      crossings: ['Hafen Latakia', 'Hafen Tartous', 'Flughafen Damaskus'],
      cta: 'Abfertigung für eine Tunesien-Sendung anfragen',
    },
  },
  algeria: {
    ar: {
      name: 'الجزائر',
      title: 'تخليص جمركي لشحنات الجزائر | الشراع',
      description: 'تخليص جمركي في سوريا لشحنات التجار الجزائريين عبر ميناء اللاذقية والمنافذ السورية.',
      h1: 'تخليص جمركي لشحنات الجزائر عبر سوريا',
      intro: 'نخدم التجار والشركات في الجزائر الذين يحتاجون إلى تخليص جمركي داخل سوريا للشحنات البحرية أو الجوية.',
      paragraphs: [
        'نتابع البيان الجمركي والكشف والإفراج للشحنات المرتبطة بالموانئ والمطارات السورية.',
        'نراجع التصنيف الجمركي والوثائق مسبقاً لتقليل زمن الانتظار.',
        'يمكن التواصل عن بعد ومتابعة الملف حتى تسليم الشحنة أو إعادة تصديرها.',
      ],
      crossingsTitle: 'المنافذ المستخدمة لشحنات الجزائر',
      crossings: ['ميناء اللاذقية', 'ميناء طرطوس', 'مطار دمشق الدولي'],
      cta: 'اطلب تخليص شحنة من الجزائر أو إليها',
    },
    en: {
      name: 'Algeria',
      title: 'Customs clearance for Algeria shipments | Al Shiraa',
      description: 'Syrian customs clearance for Algerian traders via Latakia port and Syrian gateways.',
      h1: 'Customs clearance for Algeria cargo through Syria',
      intro: 'We serve Algerian traders who need customs clearance inside Syria for sea or air shipments.',
      paragraphs: [
        'We follow declaration, inspection and release for shipments linked to Syrian ports and airports.',
        'HS classification and documents are reviewed early to reduce waiting time.',
        'Remote communication is available until delivery or re-export.',
      ],
      crossingsTitle: 'Gateways used for Algeria shipments',
      crossings: ['Latakia port', 'Tartous port', 'Damascus International Airport'],
      cta: 'Request clearance for an Algeria shipment',
    },
    de: {
      name: 'Algerien',
      title: 'Zollabfertigung für Algerien | Al Shiraa',
      description: 'Zollabfertigung in Syrien für algerische Händler über Latakia und syrische Zugänge.',
      h1: 'Zollabfertigung für Sendungen aus Algerien',
      intro: 'Wir betreuen algerische Händler, die eine Zollabfertigung in Syrien brauchen.',
      paragraphs: [
        'Wir begleiten Anmeldung, Beschau und Freigabe über syrische Häfen und Flughäfen.',
        'Tarifierung und Unterlagen werden früh geprüft.',
        'Remote-Kommunikation ist bis zur Zustellung oder zum Reexport möglich.',
      ],
      crossingsTitle: 'Zugänge für Algerien-Sendungen',
      crossings: ['Hafen Latakia', 'Hafen Tartous', 'Flughafen Damaskus'],
      cta: 'Abfertigung für eine Algerien-Sendung anfragen',
    },
  },
  morocco: {
    ar: {
      name: 'المغرب',
      title: 'تخليص جمركي لشحنات المغرب | الشراع',
      description: 'تخليص جمركي في سوريا لشحنات التجار المغاربة عبر ميناء اللاذقية والمطارات السورية.',
      h1: 'تخليص جمركي لشحنات المغرب عبر سوريا',
      intro: 'نخدم الشركات في المغرب التي تحتاج إلى تخليص جمركي داخل سوريا للشحنات الواردة أو الصادرة عبر الموانئ والمطارات السورية.',
      paragraphs: [
        'ننسّق الإفراج الجمركي ومتابعة الكشف للشحنات المرتبطة بسوريا، مع تجهيز الوثائق المطلوبة.',
        'نراجع البنود الجمركية والفاتورة وشهادة المنشأ قبل الوصول لتسريع الإجراءات.',
        'يمكن إدارة الملف عن بعد من الدار البيضاء أو الرباط أو طنجة مع تحديثات مرحلية.',
      ],
      crossingsTitle: 'المنافذ المستخدمة لشحنات المغرب',
      crossings: ['ميناء اللاذقية', 'ميناء طرطوس', 'مطار دمشق الدولي'],
      cta: 'اطلب تخليص شحنة من المغرب أو إليها',
    },
    en: {
      name: 'Morocco',
      title: 'Customs clearance for Morocco shipments | Al Shiraa',
      description: 'Syrian customs clearance for Moroccan traders via Latakia port and Syrian airports.',
      h1: 'Customs clearance for Morocco cargo through Syria',
      intro: 'We serve Moroccan companies that need customs clearance inside Syria for inbound or outbound shipments.',
      paragraphs: [
        'We coordinate customs release and inspection follow-up for Syria-linked shipments and prepare required documents.',
        'HS codes, invoices and certificates of origin are reviewed before arrival to speed procedures.',
        'Files can be managed remotely from Casablanca, Rabat or Tangier with milestone updates.',
      ],
      crossingsTitle: 'Gateways used for Morocco shipments',
      crossings: ['Latakia port', 'Tartous port', 'Damascus International Airport'],
      cta: 'Request clearance for a Morocco shipment',
    },
    de: {
      name: 'Marokko',
      title: 'Zollabfertigung für Marokko | Al Shiraa',
      description: 'Zollabfertigung in Syrien für marokkanische Händler über Latakia und syrische Flughäfen.',
      h1: 'Zollabfertigung für Sendungen aus Marokko',
      intro: 'Wir betreuen marokkanische Unternehmen, die eine Zollabfertigung in Syrien brauchen.',
      paragraphs: [
        'Wir koordinieren Freigabe und Beschau für Syrien-bezogene Sendungen.',
        'HS-Codes, Rechnung und Ursprungszeugnis werden vor Ankunft geprüft.',
        'Die Akte kann remote aus Casablanca, Rabat oder Tanger geführt werden.',
      ],
      crossingsTitle: 'Zugänge für Marokko-Sendungen',
      crossings: ['Hafen Latakia', 'Hafen Tartous', 'Flughafen Damaskus'],
      cta: 'Abfertigung für eine Marokko-Sendung anfragen',
    },
  },
};
